import React, { useMemo, useState, useCallback } from 'react';
import { StyledModal } from './style';
// utils
import { customModal, Container, Title } from '../../../utils/css/modal';
import { IModalOptions } from '../../../interfaces/admin';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import { getisIOSModalOpen } from '../../../store/actions/admin/salons.action';

const useTermsModal = () => {
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
	const [modalOptions, setModalOptions] = useState<IModalOptions>({});
	const dispatch = useDispatch();

	const openModal = useCallback(
		(options?: IModalOptions) => {
			setModalOptions(options);
			setIsModalOpen(true);
			dispatch(getisIOSModalOpen(true));
		},
		[setIsModalOpen, dispatch, setModalOptions]
	);

	const closeModal = useCallback(() => {
		setIsModalOpen(false);
		dispatch(getisIOSModalOpen(false));
	}, [setIsModalOpen, dispatch]);

	const GenericModal = useMemo(() => {
		const { options = {} } = modalOptions;
		return props => {
			return (
				<StyledModal
                    
					isOpen={isModalOpen}
					ariaHideApp={false}
					style={customModal({ ...options.style }).modal}
					shouldCloseOnOverlayClick={false}
				>    
					<Container dir={i18next.language === 'he' ? 'rtl' : 'ltr'}>
						{options.title && <Title color={props.titleColor}>{options.title}</Title>}
						{options.subtitle && (
							<p
								style={{
									fontFamily: 'RAGSans1.3Regular',
                  textAlign: 'center',
                  margin: '0 auto',
									fontSize: '24px',
									width: '420px'
								}}
							>
								{options.subtitle}
							</p>
						)}
						<div>{props.children}</div>
					</Container>
				</StyledModal>
			);
		};
	}, [isModalOpen, modalOptions]);

	return [GenericModal, isModalOpen, openModal, closeModal] as const;
};
export default useTermsModal;
